"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";

export function CardRedeemForm({
  title,
  cardNo,
  onCardNoChange,
  onSubmit,
  busy,
  error,
  success,
}: {

  title: string;
  cardNo: string;
  onCardNoChange: (value: string) => void;
  onSubmit: (event: React.FormEvent) => void;
  busy: boolean;
  error?: string | null;
  success?: string | null;
}) {
  const t = useTranslations("site.cardRedeem");

  return (
    <>
      <div className="mb-3 flex items-center gap-2">
        <svg
          className="h-5 w-5 text-amber-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
          />
        </svg>
        <span className="font-medium text-amber-800">{title}</span>
      </div>

      <form onSubmit={onSubmit} className="flex gap-2">
        <input
          autoComplete="off"
          type="text"
          value={cardNo}
          onChange={(event) => onCardNoChange(event.target.value)}
          placeholder={t("placeholder")}
          disabled={busy}
          className="flex-1 rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:border-brand focus:ring-2 focus:ring-brand/20 focus:outline-none disabled:opacity-60"
        />
        <button
          type="submit"
          disabled={busy}
          className="shrink-0 rounded-lg bg-amber-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-amber-700 disabled:opacity-60"
        >
          {busy ? t("activating") : t("activate")}
        </button>
      </form>

      {error ? <p className="mt-2 text-sm text-red-600">{error}</p> : null}
      {success ? <p className="mt-2 text-sm text-green-600">{success}</p> : null}

      <p className="mt-3 text-xs text-muted-foreground">
        {t("noCard")}
        <Link href="/member/cards/" className="ml-1 text-amber-600 hover:underline">
          {t("buy")}
        </Link>
      </p>
    </>
  );
}
